
class IncludedInPurchase {
  constructor(container) {
    this.container = container;
    this.toggleButton = this.container.querySelector('.included-in-purchase__toggle');
    this.expandableRows = this.container.querySelector('.included-in-purchase__expandable-rows');
    
    if (!this.toggleButton || !this.expandableRows) return;

    this.init();
  }

  init() {
    this.toggleButton.addEventListener('click', () => this.toggleRows());
  }

  toggleRows() {
    const isExpanded = this.toggleButton.getAttribute('aria-expanded') === 'true';
    
    if (isExpanded) {
      this.collapse();
    } else {
      this.expand();
    }
  }

  expand() {
    this.expandableRows.style.maxHeight = `${this.expandableRows.scrollHeight}px`;
    this.toggleButton.setAttribute('aria-expanded', 'true');
    this.toggleButton.textContent = this.toggleButton.dataset.seeLess;
    this.container.classList.add('is-expanded');
  }

  collapse() {
    this.expandableRows.style.maxHeight = '0px';
    this.toggleButton.setAttribute('aria-expanded', 'false');
    this.toggleButton.textContent = this.toggleButton.dataset.seeMore;
    this.container.classList.remove('is-expanded');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.included-in-purchase');
  sections.forEach(section => new IncludedInPurchase(section));
});

// Exposed for consumers that clone the snippet into other contexts
// (e.g. the purchase configurator's review pane). They can call
// `new window.IncludedInPurchase(clonedNode)` after appending the clone
// to the DOM so the See More / See Less toggle stays interactive.
window.IncludedInPurchase = IncludedInPurchase;
